module.exports = __webpack_public_path__ + "static/media/ljubljana-13.8afaa4a4.jpg";